import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetPDIResults = createModule({
  base: 'GET_PDI_RESULTS',
  apiDetails: {
    ...SERVICE_ENDPOINT.PDI_RESULTS,
    url: `${SERVICE_ENDPOINT.PDI_RESULTS.url}/list`,
    method: 'get',
  },
  errors: { defaultError: true, customError: '' },
});

const GetPDIResultById = createModule({
  base: 'GET_PDI_RESULT_BY_ID',
  apiDetails: {
    ...SERVICE_ENDPOINT.PDI_RESULTS,
    url: `${SERVICE_ENDPOINT.PDI_RESULTS.url}`,
    method: 'get'
  },
  errors: { defaultError: true, customError: '' },
});

export { GetPDIResults, GetPDIResultById };
